module.exports = __webpack_public_path__ + "static/img/default.4735c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/d_tree1_adult/default.png
// module id = NN8w
// module chunks = 1